<template>
	<div v-if="showBackdrop" class="layout-backdrop">&nbsp;</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {

	computed: {
		...mapGetters('layout', {
			'showBackdrop': 'isShowBackdrop'
		}),
	}
}
</script>
